module.exports = __webpack_public_path__ + "img/symbol_7.b8349604.png";